import { createAction, props } from '@ngrx/store';

export const pinArticle = createAction(
  '[News Feed] Pin Article',
  props<{ id: string }>(),
);

export const pinArticleSuccess = createAction(
  '[News Feed] Pin Article Success',
  props<{ id: string }>(),
);

export const pinArticleFail = createAction('[News Feed] Pin Article Fail');

export const unpinArticle = createAction(
  '[News Feed] Unpin Article',
  props<{ id: string }>(),
);

export const unpinArticleSuccess = createAction(
  '[News Feed] Unpin Article Success',
  props<{ id: string }>(),
);

export const unpinArticleFail = createAction('[News Feed] Unpin Article Fail');
